import React from 'react';
import { connect } from 'react-redux';
import { DBDropDownObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ROMMcKenzieProvisionalClassification extends React.Component {

    render() {

        let options = [
            { id: 'Derangement', value: 'Derangement' },
            { id: 'Dysfunction', value: 'Dysfunction' },
            { id: 'Postural', value: 'Postural' },
            { id: 'Other', value: 'Other' }
        ];

        return (
            <div className={styles.textfield_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='McKenzie - Provisional Classification' />
                <label className={styles.mckenzie_label}>Provisional Classification</label>
                <DBDropDownObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEROM'
                    entityKeyColumn='RONO'
                    entityKeyValue={this.props.rono}
                    field={'ROMCPROVISIONALCLASS'}
                    className={styles.mckenzie_dropdown}
                    customOptions={options}
                />
            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let rono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEROM)
        .find(key => (state.entities.notes.PTOBJECTIVEROM[key].ROEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEROM[key].RONTNO === pk && noteType !== 1)));
    let flagged = false;

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROMCPROVISIONALCLASS) {
        flagged = true;
    }

    return {
        noteId: noteId,
        rono: rono,
        flagged: flagged
    };
}

const connectedROMMcKenzieProvisionalClassification = connect(mapStateToProps)(ROMMcKenzieProvisionalClassification);
export { connectedROMMcKenzieProvisionalClassification as ROMMcKenzieProvisionalClassification };


